// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OdooTickets_MessagesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for getting ticket messages
 *
 * Response envelope:
 * {
 *   "success": true,
 *   "dados": {
 *     "messages": [...]
 *   },
 *   "error": null
 * }
 */
import type { OdooTickets_MessagesRow } from './OdooTickets_MessagesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface OdooTickets_MessagesResponseDados {
messages: OdooTickets_MessagesRow[]
}

export type OdooTickets_MessagesResponse = ApiResponse<OdooTickets_MessagesResponseDados>;

registerResponseContract('OdooTickets_MessagesResponse', {
  messages: {
    type: 'array',
    required: true,
    items: {
      id:              { type: 'number',  required: true },
      body:            { type: 'string',  required: false },
      author:          { type: 'string',  required: false },
      author_name:     { type: 'string',  required: false },
      author_id:       { type: 'number',  required: false },
      date:            { type: 'string',  required: false },
      type:            { type: 'string',  required: true },
      message_type:    { type: 'string',  required: true },
      is_user_message: { type: 'boolean', required: false },
    },
  },
})
